import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSlackChannelsQueryVariables = Types.Exact<{
  installationId: Types.Scalars['UUID']['input'];
}>;

export type GetSlackChannelsQuery = {
  __typename?: 'Query';
  slackChannels: {
    __typename?: 'SlackChannelConnection';
    totalCount: number;
    edges: Array<{
      __typename?: 'SlackChannelEdge';
      node: {
        __typename?: 'SlackChannel';
        id: any;
        slackChannelId: string;
        name?: string | null;
        installationId: any;
        channelType: Types.SlackChannelType;
        isArchived: boolean;
        createdAt: any;
        updatedAt: any;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  };
};

export const GetSlackChannelsDocument = gql`
  query GetSlackChannels($installationId: UUID!) {
    slackChannels(installationId: $installationId) {
      edges {
        node {
          id
          slackChannelId
          name
          installationId
          channelType
          isArchived
          createdAt
          updatedAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      totalCount
    }
  }
`;

/**
 * __useGetSlackChannelsQuery__
 *
 * To run a query within a React component, call `useGetSlackChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlackChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlackChannelsQuery({
 *   variables: {
 *      installationId: // value for 'installationId'
 *   },
 * });
 */
export function useGetSlackChannelsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetSlackChannelsQuery,
    GetSlackChannelsQueryVariables
  > &
    (
      | { variables: GetSlackChannelsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSlackChannelsQuery, GetSlackChannelsQueryVariables>(
    GetSlackChannelsDocument,
    options,
  );
}
export function useGetSlackChannelsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSlackChannelsQuery,
    GetSlackChannelsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetSlackChannelsQuery,
    GetSlackChannelsQueryVariables
  >(GetSlackChannelsDocument, options);
}
export function useGetSlackChannelsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetSlackChannelsQuery,
        GetSlackChannelsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetSlackChannelsQuery,
    GetSlackChannelsQueryVariables
  >(GetSlackChannelsDocument, options);
}
export type GetSlackChannelsQueryHookResult = ReturnType<
  typeof useGetSlackChannelsQuery
>;
export type GetSlackChannelsLazyQueryHookResult = ReturnType<
  typeof useGetSlackChannelsLazyQuery
>;
export type GetSlackChannelsSuspenseQueryHookResult = ReturnType<
  typeof useGetSlackChannelsSuspenseQuery
>;
export type GetSlackChannelsQueryResult = Apollo.QueryResult<
  GetSlackChannelsQuery,
  GetSlackChannelsQueryVariables
>;
